<template>
    <div>
    <v-dialog v-model="dialog" width="1200px">
        <v-card>
            <v-form ref="viewDelHsft" v-model="reviveHsftValid">
            <v-card-title class="justify-center">View deleted photo's {{ huisdel.huis_code }}</v-card-title>
            <v-divider/>
            <div class="scrollable">
                <v-row no-gutters>
                    <v-col v-for="p in huisdel.hsft_aant" :key="p" id="content" class="pa-2" cols=2>
                        <figure>
                            <figcaption>&nbsp; {{ huisdel.hsft[parseInt(p) - 1].hsft_nr }}</figcaption>
                            <img :src="huisdel.hsft[parseInt(p) - 1].hsft_foto" class="px-1" :title="huisdel.hsft[parseInt(p) - 1].hsft_tag" @click="opendialogbigdel(huisdel.hsft[parseInt(p) - 1].hsft_grote_foto)">
                            <v-checkbox v-model="selected" :value="huisdel.hsft[parseInt(p) - 1].hsft_encrid" :rules="selected_checks" label="Back to live" class="my-0"></v-checkbox> 
                        </figure>                         
                    </v-col>
                </v-row>
            </div>
            
                
            <v-divider/>
            <v-row dense class="pa-2 ma-0" cols="12">
                <span class="px-4" v-if="selected.length>0">{{ selected.length }} Photo's selected</span>
                <span class="px-4" v-else>No photo's selected</span>
                <v-spacer></v-spacer>
                <span :style="{ color: 'red' }" v-if="confirmCounter > 0">Press "confirm copy" to confirm copy of the Photo's ({{ confirmCounter }})</span>
                <span :style="{ color: 'red' }" v-else>{{ message }}</span>
            </v-row>
            <v-divider/>
            </v-form>
            <v-card-actions>
                <v-btn color="primary" small @click="selectAll()">Select All</v-btn>
                <v-btn color="primary" small @click="clearAll()">Clear selection</v-btn>
                <v-spacer/>
                <v-btn class="warning mr-3" small @click="reviveHsft()" :disabled="!reviveHsftValid">Revive Photo's</v-btn>
                <v-btn color="primary" small @click="closeDelDialog()">Close</v-btn>
            </v-card-actions>
        
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialogbigdel" width="600px">
        <v-card>
            <p class=".title ma-2">{{ huisdel.huis_code }} </p>
            <v-img :src="this.bigimage" width="600" height="450"></v-img>
            <v-container>
                <v-row dense class="flex">
                    <v-spacer />
                <v-btn color="primary" small @click="dialogbigdel = false">Close</v-btn>
            </v-row>
            </v-container>
        </v-card>
    </v-dialog>
    
    </div>
</template>

<script>
    // import { bus } from "../../../main";

    export default {
            components: {
        },
        data() { 
            return {
                dialog: false,
                dialogbigdel: false,
                bigimage: null,
                reviveHsftValid: false,
                confirmTimer: null,
                confirmCounter: 0,
                fttg_nrKeuzes: [],
                hsft: {},
                hsft_array: [],
                huisdel: {},
                selected: [],
                message: "",
                delCounter: 0,
                selected_checks: [
                    v => (v || '').length > 0 || 'Choose at least 1 photo to revive',
                ],
                items: [],
                isLoading: false,
                model: null,
                search: null,
            }
        },
        computed: {
            reactivePhotoArray: function () {
                return this.hsft_array.filter(() => {
                    return true;
                });
            }
        },
        methods: {
            open(huis_encrid) {
            this.$emit("showSnackbar");
            this.dialog = true;
            this.$axios
                .post("ares/json/ares/huis/hsft/getDelHsft.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getDelHsft"
                },
                getDelHsft: {
                    huis_encrid: huis_encrid
                }
                })
                .then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.huisdel = res.data.getDelHsft;
                }
                })
                .finally(() => {
                    this.selected = [];
                    this.loading = false;
                });
            },
            selectAll() {
                this.selected = [];
                for (let i=0; i < this.huisdel.hsft.length; i++) {
                    this.selected.push(this.huisdel.hsft[i].hsft_encrid);
                }            
            },
            clearAll() {
                this.selected = [];          
            },
            closeDelDialog() {
                this.dialog = false;
            },
            copyHsftConfirmCountdown() {
                this.confirmCounter -= 1;
                if (this.confirmCounter <= 0) {
                    clearInterval(this.confirmTimer);
                }
            },
            copyHsftConfirm() {
                this.confirmCounter = 5;
                this.confirmTimer = setInterval(this.copyHsftConfirmCountdown, 1000);
            },
            opendialogbigdel(bigimage) {
                this.bigimage = bigimage;
                this.dialogbigdel = true;
            },
            reviveHsft() {
                this.confirmCounter = 0;
                //clearInterval(this.confirmTimer);
                this.message = "Please wait: Reviving photo's";
                this.$axios.post("ares/json/ares/huis/hsft/reviveHsft.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "reviveHsft"
                    },
                    reviveHsft: {
                        hsft_encrids: this.selected,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "warning"
                        });
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.reviveHsft.text,
                            color: res.data.reviveHsft.color
                        });
                        // if (res.data.reviveHsft.color == "success") { 
                        //     bus.$emit("closeDialog", "reload");
                        // }
                        this.clearAll();
                        this.$emit('updateData');
                        this.dialog = false;
                        this.reviveHsftValid = false;
                    }
                    this.message = "";
                })
                
            },
        }
    }
</script>

<style scoped>
    .flex{
        display: flex;
        flex-direction: row;
    }
    .scrollable {
        max-height: 600px;
        overflow-x: hidden;
        overflow-y: auto;
    }
</style>
